import { EventEmitter, Injectable } from '@angular/core';
import { map, repeat } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from './base-service';
import { CommonService } from './common.service';
import * as Enums from './constants';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app'

@Injectable({
  providedIn: 'root'
})

export class AuthService extends BaseService {
  confirmationResult: firebase.auth.ConfirmationResult;
  fileName: string = 'auth.service.ts';
  public userLogin: EventEmitter<any>;
  constructor(
    private commonService: CommonService,
    private fireAuth: AngularFireAuth) {
    super();
    this.userLogin = new EventEmitter<any>();
  }

  login(obj): any {
    try {
      let data;
      if (obj.login_type === 'mobile' || obj.login_type === 'fbtoken') {
        data = {
          "password": obj.password,
          "userId": obj.userId,
          "login_type": obj.login_type,
          "timestamp": obj.timestamp,
        };
      }
      let dataObj = {
        offset: 0,
        method: 'post',
        api_url: this.getLocalloginURL(),
        local_json_file: 'local-login',
        param_data: data,
        mapcol: false
      }
      let resp = this.commonService.fetchData(dataObj);
      // resp.subscribe((data) => {
      //   if (data.status)
      //     this.userLogin.emit({ state: 'login', data_resp: data });
      // });
      return resp;
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'login(obj)',
        error: error
      }
      this.commonService.systemException(obj);
    }
  }

  logout() {
    try {
      let dataObj = {
        offset: 0,
        method: 'post',
        api_url: this.getLocalapiBaseURL() + Enums.CONSTANTS.LOGOUT_API,
        local_json_file: '',
        param_data: {},
        mapcol: false
      }
      this.userLogin.emit({ state: 'logout' });
      localStorage.clear();
      return this.commonService.fetchData(dataObj);
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'logout()',
        error: error
      }
      this.commonService.systemException(obj);
    }
  }

  globalAPI() {
    try {
      let deviceinfo = this.getLocalgetDeviceInfo();
      console.log({
        deviceinfo: deviceinfo
      })
      let dataObj = {
        offset: 0,
        method: 'post',
        api_url: Enums.CONSTANTS.GLOBAL_INIT_URL,
        local_json_file: '',
        param_data: {
          package_id: environment.packageId,
        },
        mapcol: false
      }
      return this.commonService.fetchData(dataObj);
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'globalAPI()',
        error: error
      }
      this.commonService.systemException(obj);
    }

  }

  localAPI(deviceId) {
    try {
      let deviceinfo = this.getLocalgetDeviceInfo();
      console.log({
        deviceinfo: deviceinfo
      })
      let dataObj = {
        offset: 0,
        method: 'post',
        api_url: this.getLocalapiBaseURL() + Enums.CONSTANTS.LOCAL_INIT_URL,
        local_json_file: '',
        param_data: {
          user_id: this.getLocalUserId(),
          device_id: deviceId,
          notification_settings: {},
          device_info: {
            fcm_token: this.commonService.getFCMToken(),
            os_version: deviceinfo.osVersion,
            device_version: deviceinfo.model,
            app_version: this.getAppVersion(),
            model: deviceinfo.model,
            platform: deviceinfo.platform,
            operatingSystem: deviceinfo.operatingSystem,
            osVersion: deviceinfo.osVersion,
            manufacturer: deviceinfo.manufacturer,
            isVirtual: deviceinfo.isVirtual,
            webViewVersion: deviceinfo.webViewVersion,

          }
        },
        mapcol: false
      }
      return this.commonService.fetchData(dataObj);
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'localAPI()',
        error: error
      }
      this.commonService.systemException(obj);
    }

  }

  public signInWithPhoneNumber(recaptchaVerifier, phoneNumber) {
    return new Promise<any>((resolve, reject) => {

      this.fireAuth.signInWithPhoneNumber(phoneNumber, recaptchaVerifier)
        .then((confirmationResult) => {
          this.confirmationResult = confirmationResult;
          resolve(confirmationResult);
        }).catch((error) => {
          console.log("error: ", error);
          reject('SMS not sent');
        });
    });
  }
  public async enterVerificationCode(code) {
    return new Promise<any>((resolve, reject) => {
      this.confirmationResult.confirm(code).then(async (result) => {
        console.log("result", result);
        const user = result.user;
        resolve(user);
      }).catch((error) => {
        reject(error.message);
      });

    });
  }

  verifyMobile(obj): any {
    try {      
      let dataObj = {
        offset: 0,
        method: 'post',
        api_url: this.getLocalapiBaseURL() + Enums.CONSTANTS.VERIFY_MOBILE_API,
        local_json_file: '',
        param_data: obj,
        mapcol: false
      }
      let resp = this.commonService.fetchData(dataObj);
      return resp;
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'verifyMobile(obj)',
        error: error
      }
      this.commonService.systemException(obj);
    }
  }

  verifyOtp(obj): any {
    try {      
      let dataObj = {
        offset: 0,
        method: 'post',
        api_url: this.getLocalapiBaseURL() + Enums.CONSTANTS.VERIFY_OTP_API,
        local_json_file: '',
        param_data: obj,
        mapcol: false
      }
      let resp = this.commonService.fetchData(dataObj);
      return resp;
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'verifyOtp(obj)',
        error: error
      }
      this.commonService.systemException(obj);
    }
  }
}
